export const charityConstants = (charity) => {
  return {
    CHARITY_NAME: charity.name,
    CHARITY_DESCRIPTION: charity.description,
    CHARITY_URL: charity.url,
    DONATION_STATEMENT: charity.donationStatement,
    DONATION_AMOUNT: charity.donationAmount,
  };
};

export const customerConstants = (customer) => {
  return {
    COMPANY_NAME: customer.name,
    CUSTOMER_NAME: customer.name,
    CUSTOMER_CODE: customer.customerCode,
    INDUSTRY: customer.industry,
  };
};

export const selectedBehaviourConstants = (behaviour) => {
  return {
    BEHAVIOUR_NAME: behaviour.behaviourName,
    BEHAVIOUR_ACRONYM: behaviour.behaviourAcronym,
    BEHAVIOUR_DESCRIPTION: behaviour.description,
  };
};

export const userConstants = (user) => {
  return {
    FIRSTNAME: user.firstname,
    FIRST_NAME: user.firstname,
    LASTNAME: user.lastname,
    LAST_NAME: user.lastname,
  };
};
